import React, { useCallback, useState } from "react";
import { useAppSelector } from "../../../Store";
import { useBotConfigStore } from "../../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { WidgetMainChat, WidgetMainContent } from "../../Styles/StyledScreens";
import AppRenderBannerCarousel from "../Features/AppRenderBannerCarousel";
import { MessagesScreen } from "../../screens";
import { useSelector } from "react-redux";
import { botInfoStore } from "../../../Store/Slices/socket/BotInfoSlice";
import StartScreen from "../../screens/StartScreen";
import { getLanguageSelector } from "../../../Store/Slices/socket/AllMessagesSlice";
import AppRenderStaticButtons from "../Features/AppRenderStaticButtons";

interface Props {
  children?: React.ReactNode;
  onFormSubmitted?: () => void;
  setDisableStartScreen?: (value: boolean) => void;
  setShowStartScreen?: (value: boolean) => void;
  showStartScreen?: boolean;
}

const AppChatScreenWrapper: React.FC<Props> = ({ onFormSubmitted, setDisableStartScreen, setShowStartScreen, showStartScreen }) => {
  const { botConfig } = useAppSelector(useBotConfigStore);
  const messagesEndRef = React.useRef<any>(null);
  const { isBotSetToFullScreen } = useSelector(botInfoStore);
  const [isLanguageSelection, setIsLanguageSelection] = useState<any>(false);
  const languageSelector = useAppSelector(getLanguageSelector);
  const onComplete = useCallback(() => {
    setShowStartScreen?.(false);
    setDisableStartScreen?.(false);
    onFormSubmitted?.();
  }, [setShowStartScreen, setDisableStartScreen, onFormSubmitted]);
  return (
    <WidgetMainContent
      ref={messagesEndRef}
      style={
        botConfig?.config?.background_image?.source
          ? {
              backgroundImage:
                "url(" + botConfig?.config?.background_image?.source + ")",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }
          : {}
      }
    >
      
      <WidgetMainChat
        followButtonClassName="scrollToBottomDefaultButton"
        className="WidgetMainChat"
        scrollViewClassName="styledList"
        initialScrollBehavior="auto"
        behavior="auto"
        /* react-scroll-to-bottom only accepts "bottom" | "top" (PropTypes.oneOf
           in BasicScrollToBottom.js) — "end" is invalid and silently matches
           neither branch of the library's internal mode checks, which can
           leave scroll-anchored content (like the language selector) mispositioned. */
        mode={isBotSetToFullScreen ? "top" : "bottom"}
        debug={false}
        isLanguageSelection={isLanguageSelection}
      >
        {(botConfig?.config?.start_screen || languageSelector) && showStartScreen && (
        <StartScreen onComplete={onComplete} setIsLanguageSelection={setIsLanguageSelection} setDisableStartScreen={setDisableStartScreen} onFormSubmitted={onFormSubmitted} />
      )}
        <AppRenderBannerCarousel
          isStartScreenVisible={
            !!(botConfig?.config?.start_screen || languageSelector) && !!showStartScreen
          }
        />
        <MessagesScreen />
      </WidgetMainChat>
      <AppRenderStaticButtons />
    </WidgetMainContent>
  );
};

export default AppChatScreenWrapper;
